// Lib
import { classicFormatMaxTwoDigits } from '@/utils/hooks/format/useFormatNumber';

// Types
import type { ChartType } from '@/lib/analytics/charts/chart.type';
import { SIZE_50 } from '@/lib/gridElements/size';

// Components
import { LineChart } from '@/components/composite/Charts/LineChart';

export const commentsHistoryConfig: ChartType<typeof LineChart> = {
    title: 'chart.facebook.comments_history',
    margin: { left: -20, right: 25 },
    name: {
        date: 'date',
        value: 'chart.facebook.comments_history_name',
        avg: 'chart.facebook.comments_history_avg'
    },
    id: 'comments_history',
    color: {
        value: 'yellow',
        avg: 'gray'
    },
    noLegend: true,
    valueFormat: classicFormatMaxTwoDigits,
    size: SIZE_50,
    isXAxisDate: true,
    type: 'chart',
    element: LineChart
};
